import { render, staticRenderFns } from "./CekAlacakFormWizard.vue?vue&type=template&id=920eaebc"
import script from "./CekAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./CekAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports